export const filterParse = (filterString): Record<string, { operator: string; value: string }> => {
    const filterObject = {};
    if (typeof filterString === "string" && filterString !== "") {
        filterString.split(",").forEach((filterString) => {
            const filterArray = filterString.split(";");
            filterObject[filterArray[0]] = {
                operator: filterArray[1],
                value: filterArray[2],
            };
        });
    }
    return filterObject;
};
